import { getApi } from "./util/getApi";

const fetchURL = process.env.REACT_APP_API_URL + "/campaign";
const api = getApi(fetchURL);

export const getCampaignByCampaignShortPOST = async (data: {
  campaign_short: string;
}) => api.post("/retrieveDocument", data).then((r) => r.data);

export const validateShortIdPOST = (data: { short_id: string }) =>
  api.post("/validateShortId", data).then((r) => r.data);

export const createCampaignPOST = (data: {
  short_id: string;
  user_id: number;
  name: string;
  description: string;
  default_image: string;
  goal: number;
  location: string;
  start_date_time: string;
  end_date_time: string;
  project_id: number;
}) => api.post("/insertDocument", data).then((r) => r.data);

export const getCampaignActivities = (data: { campaign_id: string }) =>
  api.post("/getActivities", data).then((r) =>{ 
  
    return r.data;
  }).catch((error) => {
    console.error("error", error);
    return error;
  });

export const getCampaignPosts = (data: { campaign_id: string }) =>
  api.post("/getPosts", data).then((r) => r.data);

export const updateCampaignPOST = (data: {
  id: string;
  short_id: string;
  name: string;
  description: string;
  default_image: string;
  goal: number;
  location: string;
  start_date_time: string;
  end_date_time: string;
  project_id: number;
}) => api.post("/updateDocument", data).then((r) => r.data);
